import { Component, type ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { SettingsService } from '../../settings/settings.service';
import { Router, ActivatedRoute } from '@angular/router';
// removed unused imports
import moment from 'moment';
import { CookieService } from 'ngx-cookie-service';

import { MatSnackBar } from '@angular/material/snack-bar';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { FullLoaderService } from 'src/app/shared/services/full-loader.service';
import { ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
// Heavy libs (xlsx, exceljs, file-saver) are dynamically imported inside methods
import { SupplierQuoteSWRService, type QuoteQuery } from './quote-swr.service';
import { Subscription } from 'rxjs';

const labelMap: Record<string, string> = {
  name: 'Name',
  address: 'Address',
  contact: 'Contact',
  phone: 'Phone',
  fax: 'Fax',
  email: 'Email',
  billingAddress: 'Billing Address',
  mpsBuyerCode: 'MPS Buyer Code',
  mpsSupplierCode: 'MPS Supplier Code',
  PIC: 'PIC',
  vat: 'VAT'

};

// Removed global alasql/XLSX wiring to avoid loading heavy libs on initial render

@Component({
  selector: 'app-supplier-quote-list',
  templateUrl: './supplier-quote-list.component.html',
  styleUrls: ['./supplier-quote-list.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SupplierQuoteListComponent {
  @ViewChild('archivedSection', { static: false })
  archivedSection!: ElementRef;
  @ViewChild('heading', { static: false })
  heading!: ElementRef;
  menuTrigger: MatMenuTrigger | null = null;
  // supplierData: any[] = [];
  showLoader: boolean = true;
  nextMpsCode: number = 0;
  searchKeyword: string = '';
  userRole!: string;
  issupplier: boolean | undefined;
  limit: number = 10; // Rows per page
  offset: number = 0; // Current page offset
  archivedLimit: number = 10; // Rows per page
  archivedOffset: number = 0; // Current page offset
  totalRecords: number = 0; // Total number of records
  archivedTotalRecords: number = 0;
  sortField: string = 'quotationSubmissionDate';
  sortDirection: string = 'DESC';
  docStatus: any;
  fromDate: any;
  toDate: any;
  operationType: string = 'supplierQuote';

  // allDocumentData: any[] = [];
  documentData: any[] = [];
  AllQuotes: any;
  archivedDocumentData: any[] = [];
  documentDataTotalRecords: number = 0;
  isFilterExpand: boolean = false;
  isArchivedExpand: boolean = false;
  archivedLoaded: boolean = false;
  searchParam: string = '';
  selectedRfq: number[] = [];
  selectedQuote: number[] = [];
  selectedRfqDetails: number[] = [];
  selectedQuoteDetails: number[] = [];
  selectedArchivedRfq: number[] = [];
  selectedArchivedQuotes: number[] = [];
  selectedStatus: string = 'ALL';
  // filterStatuses = [
  //   'Accepted',
  //   'Declined',
  //   'Draft',
  //   'Quoted',
  //   'Withdrawn',
  //   'ALL',
  // ];
  rfqStagesList = [
    { name: 'Unactioned', heading: 'RFQ Recieved:' },
    { name: 'Acknowledged', heading: 'RFQ Acknowledged:' },
    { name: 'Declined', heading: 'RFQ Declined:' },
    { name: 'Lost', heading: 'RFQ Lost:' },
    { name: 'Lapsed', heading: 'RFQ Lapsed:' },
  ];

  quoteStagesList = [
    { name: 'Accepted', heading: 'Quotation Recieved' },
    { name: 'Declined', heading: 'Quotation Declined:' },
    { name: 'Draft', heading: 'Quotation Drafted:' },

    { name: 'Withdrawn', heading: 'Quote Withdrawn:' },
    { name: 'Approved', heading: 'Quotation Approved:' },
    { name: 'Rejected', heading: 'Quotation Rejected:' },
    { name: 'Submitted', heading: 'Quotation Submitted:' },
  ];
  filterStatuses = [
    { name: 'Accepted', label: 'Quote' },
    { name: 'Declined', label: 'Quote' },
    { name: 'Draft', label: 'Quote' },
    { name: 'Quoted', label: 'Quote' },
    { name: 'Withdrawn', label: 'Quote' },
    { name: 'ALL', label: 'Quote' },
  ];
  statusColors: { [key: string]: string } = {
    Accepted: '#00B3B3',
    Quoted: '#1ebd60',
    Declined: '#FF0000',
    Withdrawn: '#fa5858',
    Draft: '#000000',
    Lost: '#FF0000',
    Lapsed: '#FF8A00',
    Unactioned: '#727272',
  };

  activeIndex: number = this.filterStatuses.length - 1;

  // {
  //     "Unactioned": 1,
  //     "Accepted": 2,
  //     "Quoted": 3,
  //     "Under Review": 4,
  //     "Clarification    Requested": 5,
  //     "Approved": 6,
  //     "Rejected": 7,
  //     "Awarded": 8,
  //     "Closed": 9,
  //     "Open": 10,
  //     "In Review": 11,
  //     "Awaiting Supplier Response": 12,
  //     "Canceled": 13,
  //     "Draft": 14,
  //     "Withdrawn": 15,
  //     "Lost": 16,
  //   };
  // quoteStatuses: { [key: number]: string } = {
  //   1: 'Unactioned',
  //   2: 'Accepted',
  //   3: 'Quoted',
  //   4: 'Under Review',
  //   5: 'Clarification Requested',
  //   6: 'Approved',
  //   7: 'Declined',
  //   8: 'Awarded',
  //   9: 'Closed',
  //   10: 'Open',
  //   11: 'In Review',
  //   12: 'Awaiting Supplier Response',
  //   13: 'Canceled',
  //   14: 'Draft',
  //   15: 'Withdrawn',
  //   16: 'Lost',
  // };
  quoteStatuses: any[] = [
    'Unactioned',
    'Accepted',
    'Quoted',
    'Under Review',
    'Clarification Requested',
    'Approved',
    'Declined',
    'Awarded',
    'Closed',
    'Open',
    'In Review',
    'Awaiting Supplier Response',
    'Canceled',
    'Draft',
    'Withdrawn',
    'Lost',
  ];

  supplierUsersList: any[] = [];
  // supplierUserMap: { [key: number]: string } = {};
  selectedUsers: any[] = [];
  useroffset: number = 0;
  userlimit: number = 10;
  isLoading: boolean = false;
  private quoteListSub: Subscription | null = null;
  private currentQuoteQueryKey: string | null = null;
  private quoteArchivedSub: Subscription | null = null;
  private currentQuoteArchivedQueryKey: string | null = null;
  // Expansion control across filters
  private hasAutoExpandedAllOnce: boolean = false;
  private shouldAutoExpandFirst: boolean = true; // initial page load for ALL

  private invalidateActiveListCache() {
    const uid = Number(this.cookieService.get('userId'));
    this.quoteSWR.invalidateMatching(
      (k) => k.startsWith('quote:') && k.includes('"activeFlag":1') && k.includes(`"userId":${uid}`)
    );
  }
  private invalidateArchivedListCache() {
    const uid = Number(this.cookieService.get('userId'));
    this.quoteSWR.invalidateMatching(
      (k) => k.startsWith('quote:') && k.includes('"activeFlag":0') && k.includes(`"userId":${uid}`)
    );
  }

  private buildQuoteQuery(activeFlag: 0 | 1): QuoteQuery {
    const fromDate = this.fromDate
      ? moment(this.fromDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;
    const toDate = this.toDate
      ? moment(this.toDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;
    return {
      searchParam: this.searchParam,
      userId: Number(this.cookieService.get('userId')),
      docStatus: this.docStatus,
      fromDate,
      toDate,
      sortField: this.sortField,
      sortDirection: this.sortDirection as any,
      limit: activeFlag === 1 ? this.limit : this.archivedLimit,
      offset: activeFlag === 1 ? this.offset : this.archivedOffset,
      activeFlag,
      operationType: this.operationType,
    };
  }

  columns = [
    { name: 'Buyer', prop: 'companyName', visible: true },
    { name: 'Document Type', prop: 'docType', visible: true },
    { name: 'Quote Reference', prop: 'quoteRefNumber', visible: true },

    { name: 'Reference', prop: 'rfqRefNumber', visible: true },
    { name: 'Approved By', prop: 'approvedBy', visible: true },
    { name: 'Status', prop: 'docStatus', visible: true },
    { name: 'Quotation Date', prop: 'quotationDate', visible: true },

    { name: 'Date', prop: 'rfqDate', visible: true },

    { name: 'Quote before date', prop: 'quotedByDate', visible: false },
    { name: 'Vessel', prop: 'vesselName', visible: false },
    { name: 'Port Country', prop: 'portCountry', visible: false },
    { name: 'Port Name', prop: 'portName', visible: false },
    { name: 'Buyer Contact Name', prop: 'contact', visible: false },
    // { name: "Supplier Contact Name", prop: "rfqRefNumber", visible: false },
    // { name: "Total Cost", prop: "approvedBy", visible: false },
    { name: 'Delivery date', prop: 'requestDeliveryDate', visible: false },
    // { name: "Expiry Date", prop: "rfqDate", visible: false },
  ];

  items = [
    {
      label: 'Request Delivery Date',
      prop: 'requestDeliveryDate',
      selected: false,
    },
    // { label: 'Quote Before Date',prop:'quotedByDate',selected:false},
    { label: 'Vessel ETA', prop: 'vesselEta', selected: false },
    { label: 'Vessel ETD', prop: 'vesselEtd', selected: false },
    { label: 'Quote before date', prop: 'quotedByDate', selected: false },
    { label: 'Price Good Until', prop: 'priceGoodUntil', selected: false },
    {
      label: 'Payment Terms',
      prop: 'paymentTermsAndConditions',
      selected: false,
    },
    { label: 'Total Price', prop: 'totalPrice', selected: false },
    { label: 'Vessel Name', prop: 'vesselName', selected: false },
  ];

  archivedItems = [
    {
      label: 'Request Delivery Date',
      prop: 'requestDeliveryDate',
      selected: false,
    },
    // { label: 'Quote Before Date',prop:'quotedByDate',selected:false},
    { label: 'Vessel ETA', prop: 'vesselEta', selected: false },
    { label: 'Vessel ETD', prop: 'vesselEtd', selected: false },
    { label: 'Quote before date', prop: 'quotedByDate', selected: false },
    { label: 'Price Good Until', prop: 'priceGoodUntil', selected: false },
    {
      label: 'Payment Terms',
      prop: 'paymentTermsAndConditions',
      selected: false,
    },
    { label: 'Total Price', prop: 'totalPrice', selected: false },
    { label: 'Vessel Name', prop: 'vesselName', selected: false },
  ];

  selectedColumns: { label: string; prop: string }[] = [];
  archivedSelectedColumns: { label: string; prop: string }[] = [];

  labelFromRFQ: string = '';


  otherStatus = [
    { name: 'Acknowledged', label: 'RFQ' },
    { name: 'Declined', label: 'RFQ' },
    { name: 'Lost', label: 'RFQ' },
    { name: 'Lapsed', label: 'RFQ' },
    { name: 'Unactioned', label: 'RFQ' },
  ]

  dropdownOpen:boolean = false;

  previewSection = false;
  previewDocs: string[] = [];

  showContactPopup:boolean = false;
  selectedBuyer: any = {
    companyName: 'N/A',
    contactPerson: 'N/A',
    email: 'N/A',
    phone: 'N/A',
    address: 'N/A',
    fax:'N/A'

  };


  constructor(
    private SettingsService: SettingsService,
    private router: Router,
    private cookieService: CookieService,
    private snack: MatSnackBar,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private fullLoaderService: FullLoaderService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private quoteSWR: SupplierQuoteSWRService,
  ) {
    iconRegistry.addSvgIcon(
      'downloadExcel',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        `${environment.assetsLink}images/excel.svg`
      )
    );
    // this.sanitizer.bypassSecurityTrustResourceUrl(`https://mps-cdn-  }
  }

  async ngOnInit() {
    const queryParams = this.route.snapshot.queryParamMap;
    console.log('query params', queryParams);

    this.route.queryParams.subscribe((params) => {
      const statusParam = params['selectedStatus'];
      const labelParam = params['label'];
      console.log('statusParam', statusParam);
      console.log('labelParam', labelParam);

      if (statusParam && labelParam) {
        //  When params are present, use them
        this.selectedStatus = statusParam;
        this.labelFromRFQ = labelParam;
        this.docStatus = statusParam;
        this.setActiveStatus(statusParam, labelParam);
      } else {
        //  Fallback when params are NOT provided
        this.docStatus = 'ALL';
        this.selectedStatus = 'ALL';
      }
    });

    this.userRole = this.cookieService.get('userRole');
    if (this.userRole == 'Suppliers') {
      this.issupplier = true;
    }

    // if (queryParams.keys.length > 0) {
    //   const updatedStatus = queryParams.get('updatedStatus');
    //   if (updatedStatus) {
    //     this.docStatus = updatedStatus;
    //     this.selectedStatus = updatedStatus;
    //     this.isFilterExpand = true;
    //   }
    // }

    await this.fetchAllDocuments();
    // Archived data will be lazy-loaded on expand via toggleArchived()
  }

  getHeadingFromLabel(label: string, entityType: 'RFQ' | 'Quote'): string {
    const list =
      entityType === 'RFQ' ? this.rfqStagesList : this.quoteStagesList;
    const match = list.find(
      (stage) => stage.name.toLowerCase() === label.toLowerCase()
    );
    return match ? match.heading : label;
  }

  isRfqLapsed(quotedByDate: string | Date): boolean {
    return new Date() > new Date(quotedByDate);
  }

  formatDate(date: string | Date): string {
    return new Date(date).toLocaleDateString('en-GB');
  }

  // buildRfqStages(rfq: any) {
  //   const sortedStages = (rfq.rfqStatusStages || []).sort(
  //     (a: any, b: any) =>
  //       new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
  //   );

  //   const stagesArray: any[] = [
  //     {
  //       heading: this.getHeadingFromLabel('Unactioned', 'RFQ'),
  //       label: 'RFQ Unactioned',
  //       date: rfq.rfqDate ? this.formatDate(rfq.rfqDate) : null,
  //       completed: true,
  //     },
  //   ];

  //   sortedStages.forEach((stage: any) => {
  //     stagesArray.push({
  //       heading: this.getHeadingFromLabel(stage.statusName, 'RFQ'),
  //       label: `RFQ ${stage.statusName}`,
  //       date: this.formatDate(stage.createdAt),
  //       completed: true,
  //     });
  //   });

  //   // If RFQ is lapsed, append it at the end (if not already in stages)
  //   if ( rfq.docStatus === 'Unactioned' &&
  //     this.isRfqLapsed(rfq.quotedByDate) &&
  //     !stagesArray.some((s) => s.label === 'Lapsed')
  //   ) {
  //     stagesArray.push({
  //       heading: this.getHeadingFromLabel('Lapsed', 'RFQ'),
  //       label: 'RFQ Lapsed',
  //       date: this.formatDate(rfq.quotedByDate),
  //       completed: true,
  //     });
  //   }

  //   return stagesArray;
  // }

  setActiveStatus(status: string, label: string) {
    const index = this.filterStatuses.findIndex(
      (s) => s.name === status && s.label === label
    );
    if (index !== -1) {
      this.activeIndex = index;
      this.selectedStatus = status;
      this.docStatus = status;
    } else {
      //  If not found, still default to ALL
      this.docStatus = 'ALL';
      this.selectedStatus = 'ALL';
    }
  }

  async toggleUserSelection(item: any) {
    // console.log("item",item);
    // console.log("this.selectedRfq",this.selectedRfq);
    // Check if any RFQs are selected
    if (this.selectedRfq.length === 0) {
      // If no RFQs are selected, show a snackbar message and return
      this.snack.open(
        'Please select at least one Quote before selecting a user.',
        'OK',
        {
          duration: 3000,
        }
      );
      return;
    }

    // Check if the user is already selected
    item.selected = !item.selected; // Toggle selection for the user

    // If the user is selected, call the API to assign the supplier-user to the RFQ
    if (item.selected) {
      try {
        // Call the SettingsService to assign the user
        this.fullLoaderService.showLoader('Assigning user...');
        const response = await this.SettingsService.assignQuoteToSupplierUser(
          this.selectedRfq,
          Number(this.cookieService.get('userId')),
          item.id
        );
        // const result= await this.SettingsService.fetchSupplierUserByRfqId(this.selectedRfq[0]);
        // console.log({result});
        // Targeted invalidation: only active list cache
        this.invalidateActiveListCache();
        await this.fetchAllDocuments();
        this.selectedRfq = [];
        item.selected = false;

        this.snack.open('User assigned to Quote successfully.', 'OK', {
          duration: 3000,
        });
        this.fullLoaderService.hideLoader();
      } catch (error) {
        // If the API call fails, handle the error here
        this.snack.open('Failed to assign user to Quote.', 'OK', {
          duration: 3000,
        });
        throw error; // Re-throw the error to be caught in the calling method
      }
    }
  }

  // Method to get status color based on the status
  getStatusColor(status: string): string {
    return this.statusColors[status] || '#000000'; // Default to black if no match
  }

  formatRfqDate(rfqDate: any): string {
    const now = moment(); // Get current time
    const diffInSeconds = now.diff(moment(rfqDate), 'seconds');
    const diffInMinutes = now.diff(moment(rfqDate), 'minutes');
    const diffInHours = now.diff(moment(rfqDate), 'hours');
    const diffInDays = now.diff(moment(rfqDate), 'days');

    // Handle the difference based on time
    if (diffInSeconds < 60) {
      return `${diffInSeconds} seconds ago`;
    } else if (diffInMinutes < 60) {
      return `${diffInMinutes} minutes ago`;
    } else if (diffInHours < 24) {
      return `${diffInHours} hours ago`;
    } else if (diffInDays === 1) {
      return 'Yesterday';
    } else {
      return moment(rfqDate).format('DD MMM YYYY'); // Show date with month and year
    }
  }

  // downloadDocumentDataExcel() {
  //   // Show loader during the export process
  //   this.fullLoaderService.showLoader();

  //   let formattedData: any = [];

  //   // Iterate through the document data and format it as needed
  //   this.documentData.forEach((document) => {
  //     formattedData.push({
  //       Reference: document.rfqRefNumber,
  //       Vessel: document.vesselName,
  //       'Port Name': document.portName,
  //       Buyer: document.companyName,
  //       'Quotation Date': moment(document.quotedByDate).format('DD/MM/YYYY'),
  //       Owner: document.buyerDetails.supplierName,
  //       Status: document.docStatus,
  //       'RFQ Date': document.rfqDate,
  //       'Request Delivery Date': moment(document.requestDeliveryDate).format(
  //         'DD/MM/YYYY'
  //       ),
  //       'Quote Before Date': moment(document.quotedByDate).format('DD/MM/YYYY'),
  //       'Vessel ETA': moment(document.vesselEta).format('DD/MM/YYYY'),
  //       'Vessel ETD': moment(document.vesselEtd).format('DD/MM/YYYY'),
  //     });
  //   });

  //   // Create a new worksheet from the formatted data
  //   const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(formattedData);
  //   const wb: XLSX.WorkBook = XLSX.utils.book_new();

  //   // Append the worksheet to the workbook
  //   XLSX.utils.book_append_sheet(wb, ws, 'Document Data');

  //   // Write the file to disk or trigger the download
  //   XLSX.writeFile(wb, 'Document Data Export.xlsx');

  //   // Hide the loader after the export is complete
  //   this.fullLoaderService.hideLoader();
  // }
  async fetchAllQuotes() {
    try {
      this.operationType = 'exportAll';
      console.log('During export hit docStatus->', this.docStatus);
      const response = await this.SettingsService.fetchQuoteDetailsBySupplierId(
        this.searchParam,
        Number(this.cookieService.get('userId')),
        this.docStatus,
        null,
        null,
        '',
        '',
        0,
        0,
        1,
        this.operationType
      );
      // console.log('Response from exportAllServicesByAdmin:', response);
      if (response && Array.isArray(response.rows)) {
        this.AllQuotes = response.rows;
      } else {
        console.error('Invalid response structure', response);
      }

      // console.log('Fetched All Quotes Data:', this.AllQuotes);
    } catch (error) {
      console.error('Error fetching all Quotes:', error);
      throw error; // Rethrow the error to be handled by the caller
    }
  }
  async exportAllQuotes() {
    try {
      this.fullLoaderService.showLoader('Exporting Quote Details...');

      // Dynamically import XLSX to avoid adding it to initial bundle
      const XLSX = await import('xlsx');

      await this.fetchAllQuotes();

      if (!this.AllQuotes || this.AllQuotes.length === 0) {
        alert('No Quotes available to export.');
        return;
      }
      console.log('All Quotes Data:', this.AllQuotes);

      const exportData: any[] = [];

      this.AllQuotes.forEach((quotes: any, index: number) => {
        const flattenedProduct = {
          'Sr. No.': index + 1,
          'Quote Reference': quotes.quoteRefNumber || '',
          'RFQ Reference': quotes.rfqRefNumber || '',
          'Port Name': quotes.portName || '',
          'Vessel Name': quotes.vesselName || '',
          Buyer: quotes.companyName || '',
          Status: this.quoteStatuses[quotes.quoteStatus - 1] || '',
          'Quote Submission Date': quotes.quotationDate || '',
          'Request For Delivery Date': quotes.requestDeliveryDate || '',
          'Quote Before Date': quotes.quotedByDate || '',
          'Vessel ETA': quotes.vesselEta || '',
          'Vessel ETD': quotes.vesselEtd || '',
          'Price Good Until': quotes.priceGoodUntil || '',
          'Payment Terms': quotes.paymentTermsAndConditions || '',
          'Total Price': quotes.totalPrice || '',
        };

        exportData.push(flattenedProduct);
      });

      const today = new Date();
      const formattedDate = `${String(today.getDate()).padStart(
        2,
        '0'
      )}-${String(today.getMonth() + 1).padStart(
        2,
        '0'
      )}-${today.getFullYear()}`;
      const fileName = `Supplier_Quotation_List_${formattedDate}.xlsx`;

      // Use XLSX to export data
      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Quotes');
      XLSX.writeFile(wb, fileName);

      this.snack.open('Quotes data exported successfully!', 'OK', {
        duration: 5000,
      });
    } catch (error) {
      console.error('Error while exporting Quotes:', error);
      this.snack.open('Failed to export Quotes data.', 'OK', {
        duration: 5000,
      });
    } finally {
      //this.importExportOperationLoader = false;
      this.fullLoaderService.hideLoader();
    }
  }

  onStatusSelect(status: string, index: number, label: string) {
    if (this.selectedStatus.includes(status)) {
      return;
    }
    if (label === 'Quote') {
      this.activeIndex = index;
      this.selectedStatus = status;
      this.offset = 0;
      this.docStatus = status;
      // Reset expansion on filter change; only auto-expand once for ALL on first load
      this.expandedQuoteId = null;
      this.shouldAutoExpandFirst = status === 'ALL' && !this.hasAutoExpandedAllOnce;
      console.log(
        'triggered status selection and now docstatus->',
        this.docStatus
      );
      this.fetchAllDocuments();
    } else if (label === 'RFQ') {
      this.router.navigate(['/operations/supplier-rfq-list'], {
        queryParams: {
          selectedStatus: status,
          label: label,
        },
      });
    }
  }

  getRemainingTime(row: any): {
    label: string;
    color: string;
    tooltip: string;
  } {
    if (!row.quotedByDate || ['Lost', 'Declined'].includes(row.docStatus)) {
      if (row.docStatus == 'Declined') {
        return {
          label: '-',
          color: 'black',
          tooltip: 'You have declined this RFQ',
        };
      } else if (row.docStatus == 'Lost') {
        return {
          label: '-',
          color: 'black',
          tooltip: 'RFQ awarded to another Supplier',
        };
      }
      return {
        label: '-',
        color: 'black',
        tooltip: 'Quotation date Deadline not mentioned',
      };
    }

    const now = moment();
    const quoteDate = moment(row.quotedByDate);
    const diffInDays = quoteDate.diff(now, 'days');

    if (diffInDays > 7) {
      return {
        label: `New`,
        color: '#0BA716',
        tooltip: `RFQ due in ${diffInDays} days`,
      };
    } else if (diffInDays >= 4 && diffInDays <= 7) {
      return {
        label: `Standard`,
        color: '#FD8900',
        tooltip: `RFQ due in ${diffInDays} days`,
      };
    } else if (diffInDays >= 1 && diffInDays <= 3) {
      return {
        label: `Urgent`,
        color: '#F60303',
        tooltip: `RFQ due in ${diffInDays} days`,
      };
    } else if (diffInDays < 0) {
      // return { label: 'Overdue', color: '#000000', tooltip: 'Quote window closed' };
      return { label: '-', color: '#000000', tooltip: 'Quote window closed' };
    } else {
      const diffInHours = quoteDate.diff(now, 'hours');
      const diffInMinutes = quoteDate.diff(now, 'minutes');
      const diffInSeconds = quoteDate.diff(now, 'seconds');

      if (diffInHours >= 1) {
        return {
          label: `Urgent (${diffInHours} hr${diffInHours > 1 ? 's' : ''} Left)`,
          color: '#F60303',
          tooltip: `RFQ due in ${diffInHours} hours`,
        };
      } else if (diffInMinutes >= 1) {
        return {
          label: `Urgent (${diffInMinutes} min${
            diffInMinutes > 1 ? 's' : ''
          } Left)`,
          color: '#F60303',
          tooltip: `RFQ due in ${diffInMinutes} minutes`,
        };
      } else if (diffInSeconds >= 1) {
        return {
          label: `Urgent (${diffInSeconds} sec${
            diffInSeconds > 1 ? 's' : ''
          } Left)`,
          color: '#F60303',
          tooltip: `RFQ due in ${diffInSeconds} seconds`,
        };
      } else {
        // return { label: 'Overdue', color: '#000000', tooltip: 'Quote window closed'};
        return { label: '-', color: '#000000', tooltip: 'Quote window closed' };
      }
    }
  }

  getRemainingTimeForQuoteDate(row: any): {
    label: string;
    color: string;
    tooltip: string;
  } {
    const now = moment();
    const quoteDate = moment(row.quotedByDate);
    const diffInDays = quoteDate.diff(now, 'days');

    if (diffInDays > 7) {
      return {
        label: `New`,
        color: '#0BA716',
        tooltip: `RFQ due in ${diffInDays} days`,
      };
    } else if (diffInDays >= 4 && diffInDays <= 7) {
      return {
        label: `Standard`,
        color: '#FD8900',
        tooltip: `RFQ due in ${diffInDays} days`,
      };
    } else if (diffInDays >= 1 && diffInDays <= 3) {
      return {
        label: `Urgent`,
        color: '#F60303',
        tooltip: `RFQ due in ${diffInDays} days`,
      };
    } else if (diffInDays < 0) {
      return {
        label: 'Overdue',
        color: '#000000',
        tooltip: 'Quote window closed',
      };
    } else {
      const diffInHours = quoteDate.diff(now, 'hours');
      const diffInMinutes = quoteDate.diff(now, 'minutes');
      const diffInSeconds = quoteDate.diff(now, 'seconds');

      if (diffInHours >= 1) {
        return {
          label: `Urgent (${diffInHours} hr${diffInHours > 1 ? 's' : ''} Left)`,
          color: '#F60303',
          tooltip: `RFQ due in ${diffInHours} hours`,
        };
      } else if (diffInMinutes >= 1) {
        return {
          label: `Urgent (${diffInMinutes} min${
            diffInMinutes > 1 ? 's' : ''
          } Left)`,
          color: '#F60303',
          tooltip: `RFQ due in ${diffInMinutes} minutes`,
        };
      } else if (diffInSeconds >= 1) {
        return {
          label: `Urgent (${diffInSeconds} sec${
            diffInSeconds > 1 ? 's' : ''
          } Left)`,
          color: '#F60303',
          tooltip: `RFQ due in ${diffInSeconds} seconds`,
        };
      } else {
        return {
          label: 'Overdue',
          color: '#000000',
          tooltip: 'Quote window closed',
        };
      }
    }
  }

  async onUserMenuOpened() {
    console.log('User menu opened');
    console.log('Current supplierUsersList:', this.supplierUsersList)
    if (!this.supplierUsersList.length && !this.isLoading) {
      await this.fetchUsers();
    }
    console.log('Supplier Users List:', this.supplierUsersList);
  }

  async fetchAllDocuments() {
    let fromDate = this.fromDate
      ? moment(this.fromDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;
    let toDate = this.toDate
      ? moment(this.toDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;

    this.operationType = 'supplierQuote';
    try {
      const q: QuoteQuery = {
        searchParam: this.searchParam,
        userId: Number(this.cookieService.get('userId')),
        docStatus: this.docStatus,
        fromDate,
        toDate,
        sortField: this.sortField,
        sortDirection: this.sortDirection as any,
        limit: this.limit,
        offset: this.offset,
        activeFlag: 1,
        operationType: this.operationType,
      };

      const key = this.quoteSWR.keyOf(q);
      const needsResubscribe = this.currentQuoteQueryKey !== key;
      // Show loader only for the very first load of this page (no cache)
      const cached = this.quoteSWR.getCached(q);
      this.showLoader = !cached;
      if (needsResubscribe) {
        if (this.quoteListSub) {
          this.quoteListSub.unsubscribe();
          this.quoteListSub = null;
        }
        this.currentQuoteQueryKey = key;
        this.quoteListSub = this.quoteSWR.getList$(q, true).subscribe(async (response) => {
          if (!response || !Array.isArray(response.rows)) return;
          const enrichedRows = await Promise.all(
            response.rows.map(async (row: any) => {
              const r = { ...row };
              const currentDate = new Date();
              const quotedByDate = new Date(r.quotedByDate);
              if (r.docStatus === 'Unactioned' && quotedByDate < currentDate) {
                r.docStatus = 'Lapsed';
              }
              // Normalize id for UI identity
              r.id = r.id ?? r.quoteId;
              // Precompute UI fields
              r.statusColor = this.statusColors?.[r.docStatus] || '#727272';
              r.rfqDateFormatted = r.rfqDate ? moment(r.rfqDate).format('DD/MM/YYYY') : '-';
              r.quotationDateFormatted = r.quotationDate ? moment(r.quotationDate).format('DD/MM/YYYY') : '-';
              r.remaining = this.getRemainingTime(r);
              r.remainingQuote = this.getRemainingTimeForQuoteDate(r);
              return r;
            })
          );
          this.documentData = enrichedRows;
          // Expansion logic: only auto-expand once for ALL on initial load
          if (this.expandedQuoteId == null && this.documentData.length > 0 && this.shouldAutoExpandFirst) {
            const first = this.documentData[0];
            this.expandedQuoteId = first.quoteId;
            if (!first.statusesStages) {
              first.statusesStages = this.buildRfqStages(first);
              first.statusesStages = this.buildQuoteStages(first);
              first.statusesStages = this.buildOtherStages(first);
            }
            this.hasAutoExpandedAllOnce = true;
            this.shouldAutoExpandFirst = false;
          }
          // If a row is already marked as expanded (e.g., user toggled), ensure it has stages
          if (this.expandedQuoteId != null) {
            const match = this.documentData.find((r: any) => r.quoteId === this.expandedQuoteId);
            if (match && !match.statusesStages) {
              match.statusesStages = this.buildRfqStages(match);
              match.statusesStages = this.buildQuoteStages(match);
              match.statusesStages = this.buildOtherStages(match);
            }
          }
          this.totalRecords = response.totalElements ?? 0;
          this.documentData = [...this.documentData];
          this.showLoader = false;
          this.cdr.markForCheck();
        });
      }
      if (!cached) {
        this.fullLoaderService.showLoader();
        try {
          await this.quoteSWR.refresh(q);
        } finally {
          this.fullLoaderService.hideLoader();
        }
      } else {
        this.quoteSWR.refresh(q);
      }
    } catch (error) {
      console.error('Error fetching documents', error);
    } finally {
      this.showLoader = false;
      this.cdr.markForCheck();
    }
  }

  async fetchArchivedAllDocuments() {
    let fromDate = this.fromDate
      ? moment(this.fromDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;
    let toDate = this.toDate
      ? moment(this.toDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;

    this.operationType = 'supplierQuote';

    try {
      const q: QuoteQuery = {
        searchParam: this.searchParam,
        userId: Number(this.cookieService.get('userId')),
        docStatus: this.docStatus,
        fromDate,
        toDate,
        sortField: this.sortField,
        sortDirection: this.sortDirection as any,
        limit: this.archivedLimit,
        offset: this.archivedOffset,
        activeFlag: 0,
        operationType: this.operationType,
      };

      const key = this.quoteSWR.keyOf(q);
      const needsResubscribe = this.currentQuoteArchivedQueryKey !== key;
      // Show loader only when this archived page has no cache yet
      const cached = this.quoteSWR.getCached(q);
      this.showLoader = !cached;
      if (needsResubscribe) {
        if (this.quoteArchivedSub) {
          this.quoteArchivedSub.unsubscribe();
          this.quoteArchivedSub = null;
        }
        this.currentQuoteArchivedQueryKey = key;
        this.quoteArchivedSub = this.quoteSWR.getList$(q, true).subscribe(async (response) => {
          if (!response || !Array.isArray(response.rows)) return;
          const enrichedRows = await Promise.all(
            response.rows.map(async (row: any) => {
              const currentDate = new Date();
              const quotedByDate = new Date(row.quotedByDate);
              if (row.docStatus === 'Unactioned' && quotedByDate < currentDate) {
                row.docStatus = 'Lapsed';
              }
              // Normalize id and precompute UI fields for archived as well
              row.id = row.id ?? row.quoteId;
              row.statusColor = this.statusColors?.[row.docStatus] || '#727272';
              row.rfqDateFormatted = row.rfqDate ? moment(row.rfqDate).format('DD/MM/YYYY') : '-';
              row.quotationDateFormatted = row.quotationDate ? moment(row.quotationDate).format('DD/MM/YYYY') : '-';
              row.remaining = this.getRemainingTime(row);
              row.remainingQuote = this.getRemainingTimeForQuoteDate(row);
              return row;
            })
          );
          this.archivedDocumentData = enrichedRows;
          this.archivedTotalRecords = response.totalElements ?? 0;
          this.showLoader = false;
          this.cdr.markForCheck();
        });
      }
      if (!cached) {
        this.fullLoaderService.showLoader();
        try {
          await this.quoteSWR.refresh(q);
        } finally {
          this.fullLoaderService.hideLoader();
        }
      } else {
        this.quoteSWR.refresh(q);
      }
    } catch (error) {
      console.error('Error fetching archived documents', error);
    } finally {
      this.showLoader = false;
      this.cdr.markForCheck();
    }
  }

  setRowClass = (row: any) => {
    return 'green-row-background';
  };

  rowIdentity = (row: any) => row.quoteId;

  toggleSelection(item: any) {
    item.selected = !item.selected;
    console.log(
      'Selected items:',
      this.items.filter((i) => i.selected)
    );
    this.updateSelectedColumns();
  }

  archivedToggleSelection(item: any) {
    item.selected = !item.selected;
    console.log(
      'Selected items:',
      this.archivedItems.filter((i) => i.selected)
    );
    this.updateArchivedSelectedColumns();
  }

  onScroll(): void {
    const menuContent = document.querySelector('.menu-content') as HTMLElement;
    // Check if we've reached the bottom of the menu content
    if (
      menuContent.scrollTop + menuContent.clientHeight >=
        menuContent.scrollHeight &&
      !this.isLoading
    ) {
      if (this.supplierUsersList.length == this.userlimit * this.useroffset) {
        this.fetchUsers();
      } else {
        this.isLoading = false;
      }
    }
  }

  // Fetch users based on pagination offset and limit
  async fetchUsers(): Promise<void> {
    this.isLoading = true;

    try {
      const response = await this.SettingsService.fetchUserBySupplierId(
        Number(this.cookieService.get('userId')), // supplierId
        this.userlimit, // limit
        this.useroffset // offset
      ).toPromise();

      if (response && Array.isArray(response.rows)) {
        this.supplierUsersList = [...this.supplierUsersList, ...response.rows];
        this.useroffset++; // Increment offset for next batch of users

        console.log('supplierUserList', this.supplierUsersList);
      } else {
        console.error('Invalid response structure:', response);
      }
    } catch (error) {
      console.error('Error fetching supplier users:', error);
    } finally {
      this.isLoading = false;
    }
  }

  updateSelectedColumns() {
    // Create a map of label to prop
    this.selectedColumns = this.items
      .filter((item) => item.selected) // Filter selected items
      .map((item) => ({ label: item.label, prop: item.prop })); // Create key-value pairs (label -> prop)
  }

  updateArchivedSelectedColumns() {
    this.archivedSelectedColumns = this.archivedItems
      .filter((item) => item.selected) // Filter selected items
      .map((item) => ({ label: item.label, prop: item.prop })); // Create key-value pairs (label -> prop)

    console.log('archieve selected columns', this.archivedSelectedColumns);
  }
  isDate(value: any): boolean {
    return value instanceof Date || !isNaN(Date.parse(value));
  }

  // Method to handle page change event from ngx-datatable
  onPageChange(event: any) {
    this.offset = event.offset; // Update offset from the page change event
    this.selectedRfq = [];
    this.fetchAllDocuments(); // Fetch data with new offset
  }

  // Method to handle search functionality
  onSearch() {
    setTimeout(() => {
      this.offset = 0;

      this.fetchAllDocuments();
    }, 0);
  }

  // Handle sort change event from ngx-datatable
  onSort(event: any) {
    const sort = event.sorts[0];
    this.sortField = sort.prop;
    this.sortDirection = sort.dir;

    // Apply sorting and fetch data accordingly
    // Note: Sorting in your backend should be implemented to support `sortField` and `sortDirection`
    this.fetchAllDocuments();
  }

  onArchivedSort(event: any) {}

  onArchivedPageChange(event: any) {
    this.archivedOffset = event.offset; // Update offset from the page change event
    this.fetchArchivedAllDocuments(); // Fetch data with new offset
  }

  async OpenRfq(rfqDetailsId: number, supplierId: number) {
    const newWindow = window.open('', '_blank'); // Open immediately

    if (!newWindow) {
      alert('Popup blocked. Please allow popups for this site.');
      return;
    }

    let data = {
      supplierId: supplierId,
      rfqId: rfqDetailsId,
    };

    try {
      const pdf = await this.SettingsService.generateSupplierRfqAttachment(
        data
      );
      const uint8Array = new Uint8Array(pdf.data);
      const blob = new Blob([uint8Array], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);

      newWindow.location.href = url;
    } catch (error) {
      newWindow.close(); // Cleanup
      console.error('Failed to open RFQ PDF', error);
      alert('Failed to open PDF. Please try again.');
    }
  }

  async downloadRfq(rfqDetailsId: number, supplierId: number, refNo: string) {
    this.showLoader = true;

    let fileName = refNo + '.pdf';

    let data = {
      supplierId: supplierId,
      rfqId: rfqDetailsId,
    };
    const pdf = await this.SettingsService.generateSupplierRfqAttachment(data);

    const uint8Array = new Uint8Array(pdf.data);
    const blob = new Blob([uint8Array], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);

    // Create a temporary <a> element
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    this.showLoader = false;
  }

  OpenSupplierProductPopUp(isNew?: boolean, row?: any, userId?: any) {
    this.router.navigate(
      [
        'dataManagement',
        {
          outlets: {
            'form-outlet': ['product-binding', userId],
          },
        },
      ],
      {
        state: { supplierId: userId }, // Add your data here
      }
    );
  }

  OpenSupplierPreviewPopup(row?: any, userId?: any, companyId?: any) {
    this.router.navigate([
      // "dataManagement",
      // 'pro',
      //  userId
      'settings',
      'profile',
      'about',
      userId,
      companyId,
    ]);
  }

  OpenSupplierProfilePopup(row?: any, userId?: any, companyId?: any) {
    this.router.navigate(['settings', 'supplierProfile', userId, companyId]);
  }

  exportAll() {
    (async () => {
      this.fullLoaderService.showLoader('Exporting...');
      const XLSX = await import('xlsx');
      const exportData: any[] = this.documentData.map((docDetails) => ({
        Buyer: docDetails.companyName,
        'Document Type': docDetails.docType,
        Reference: docDetails.rfqRefNumber,
        Status: docDetails.docStatus,
        Date: docDetails.rfqDate,
      }));
      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'RFQs');
      XLSX.writeFile(wb, 'RFQ Data.xlsx');
      this.fullLoaderService.hideLoader();
    })();
  }

  toggleVisibility() {
    this.isFilterExpand = !this.isFilterExpand;
  }

  async toggleArchived() {
    this.isArchivedExpand = !this.isArchivedExpand;
    if (this.isArchivedExpand) {
      // Lazy-load archived data on first expand
      if (!this.archivedLoaded) {
        await this.fetchArchivedAllDocuments();
        this.archivedLoaded = true;
      }

      if (this.heading) {
        this.heading.nativeElement.scrollIntoView({
          behavior: 'smooth', // Smooth scroll
          block: 'start', // Align the section to the top of the viewport
        });
        setTimeout(() => {
          if (this.archivedSection) {
            this.heading.nativeElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start', // Align the table at the top of the viewport after heading
            });
          }
        }, 100);
      }
    }
  }

  isColumnVisible(prop: string): boolean {
    const column = this.columns.find((col) => col.prop === prop);
    return column ? column.visible : false;
  }

  search() {}
  cancelFilter() {
    this.fromDate = null;
    this.toDate = null;
    this.offset = 0;
    this.archivedOffset = 0;
    this.selectedStatus = 'ALL';
    this.docStatus = '';
    this.fetchAllDocuments();
    this.fetchArchivedAllDocuments();
  }

  toggleColumn(column: any) {
    column.visible = !column.visible;
  }

  toggleSelectAll(event: any, section: string) {
    const checked = event.target.checked;
    // const ids = this.documentData.map(item => item.supplierRfqDetailsId);
    const ids = this.documentData.map((item) => item.quoteId);

    if (section == 'active') {
      if (checked) {
        // this.selectedRfq = this.documentData.map(item => item.supplierRfqDetailsId);
        this.selectedRfq = this.documentData.map((item) => item.quoteId);
      } else {
        this.selectedRfq = [];
      }
    } else {
      if (checked) {
        this.selectedArchivedRfq = this.archivedDocumentData.map(
          (item) => item.quoteId
        );
      } else {
        this.selectedArchivedRfq = [];
      }
    }
  }

  selectDeselectRfq(
    event: any,
    supplierRfqDetailsId: any,
    quoteId: any,
    section: string,
    owner: any
  ) {
    const checked = event.target.checked;

    if (section == 'active') {
      if (checked) {
        this.selectedRfq.push(quoteId);
        //  this.selectedRfqDetails.push(supplierRfqDetailsId);
        console.log('owner', owner);
        if (owner !== null) {
          this.snack.open(
            `User is already assigned to Quote ID ${quoteId}`,
            'OK',
            {
              duration: 5000,
            }
          );
        }
      } else {
        this.selectedRfq = this.selectedRfq.filter((id) => id !== quoteId);
      }
    } else {
      if (checked) {
        this.selectedArchivedRfq.push(quoteId);
      } else {
        this.selectedArchivedRfq = this.selectedArchivedRfq.filter(
          (id) => id !== quoteId
        );
      }
    }
  }

  async rfqOperation(operation: string) {
    if (operation == 'unarchive') {
      if (this.selectedArchivedRfq.length == 0) {
        this.snack.open('Please select atleast one', 'OK', {
          duration: 3000,
        });
        return;
      }

      this.showLoader = true;
      await this.SettingsService.quoteOperations({
        operation: operation,
        selectedRfqId: this.selectedArchivedRfq,
      });

      // Optimistically move items from archived -> active
      const unarchivedIds = new Set(this.selectedArchivedRfq);
      const toUnarchive = this.archivedDocumentData.filter((row: any) => unarchivedIds.has(row.quoteId));
      this.archivedDocumentData = this.archivedDocumentData.filter((row: any) => !unarchivedIds.has(row.quoteId));
      // If active list is present, prepend the unarchived rows
      if (toUnarchive.length > 0) {
        this.documentData = [...toUnarchive, ...this.documentData];
        this.totalRecords += toUnarchive.length;
        this.archivedTotalRecords = Math.max(0, this.archivedTotalRecords - toUnarchive.length);
      }

      // Patch caches for current pages
      const qArchived = this.buildQuoteQuery(0);
      const qActive = this.buildQuoteQuery(1);
      this.quoteSWR.patchList(qArchived, (resp: any) => {
        const rows = (resp?.rows || []).filter((r: any) => !unarchivedIds.has(r.quoteId));
        const total = Math.max(0, (resp?.totalElements ?? 0) - toUnarchive.length);
        return { ...resp, rows, totalElements: total };
      });
      this.quoteSWR.patchList(qActive, (resp: any) => {
        const rows = toUnarchive.concat(resp?.rows || []);
        const total = (resp?.totalElements ?? 0) + toUnarchive.length;
        return { ...resp, rows, totalElements: total };
      });

      this.snack.open('Items unarchived', 'OK', {
        duration: 3000,
      });
    } else {
      if (this.selectedRfq.length == 0) {
        this.snack.open('Please select atleast one.', 'OK', {
          duration: 3000,
        });
        return;
      }

      let data = {
        operation: operation,
        selectedRfqId: this.selectedRfq,
      };

      if (operation == 'archive') {
        this.showLoader = true;
        await this.SettingsService.quoteOperations(data);

        // Optimistically move items from active -> archived
        const archivedIds = new Set(this.selectedRfq);
        const toArchive = this.documentData.filter((row: any) => archivedIds.has(row.quoteId));
        this.documentData = this.documentData.filter((row: any) => !archivedIds.has(row.quoteId));
        if (toArchive.length > 0 && this.archivedLoaded) {
          this.archivedDocumentData = [...toArchive, ...this.archivedDocumentData];
          this.archivedTotalRecords += toArchive.length;
        }
        this.totalRecords = Math.max(0, this.totalRecords - toArchive.length);

        // Patch caches for current pages
        const qActive = this.buildQuoteQuery(1);
        const qArchived = this.buildQuoteQuery(0);
        this.quoteSWR.patchList(qActive, (resp: any) => {
          const rows = (resp?.rows || []).filter((r: any) => !archivedIds.has(r.quoteId));
          const total = Math.max(0, (resp?.totalElements ?? 0) - toArchive.length);
          return { ...resp, rows, totalElements: total };
        });
        if (this.archivedLoaded) {
          this.quoteSWR.patchList(qArchived, (resp: any) => {
            const rows = toArchive.concat(resp?.rows || []);
            const total = (resp?.totalElements ?? 0) + toArchive.length;
            return { ...resp, rows, totalElements: total };
          });
        }
        // Reset expanded row if needed
        if (this.expandedQuoteId && archivedIds.has(this.expandedQuoteId)) {
          this.expandedQuoteId = null;
          if (this.documentData.length > 0) {
            const first = this.documentData[0];
            this.expandedQuoteId = first.quoteId;
            if (!first.statusesStages) {
              first.statusesStages = this.buildRfqStages(first);
              first.statusesStages = this.buildQuoteStages(first);
              first.statusesStages = this.buildOtherStages(first);
            }
          }
        }

        this.snack.open('Items archived', 'OK', {
          duration: 3000,
        });
      }
      // } else if (operation == 'markAsOpen') {
      //   this.showLoader = true;
      //   await this.SettingsService.rfqOperations(data);
      //   this.showLoader = false;
      //   this.snack.open('Items marked as open', 'OK', {
      //     duration: 3000,
      //   });
      // } else if (operation == 'markAsUnopen') {
      //   this.showLoader = true;
      //   await this.SettingsService.rfqOperations(data);
      //   this.showLoader = false;
      //   this.snack.open('Items marked as unopen', 'OK', {
      //     duration: 3000,
      //   });
      // }
    }

    // Background revalidation only; no blocking loaders
    const qActive = this.buildQuoteQuery(1);
    const qArchived = this.buildQuoteQuery(0);
    this.quoteSWR.refresh(qActive);
    if (this.archivedLoaded) {
      this.quoteSWR.refresh(qArchived);
    }
    this.selectedArchivedRfq = [];
    this.selectedRfq = [];
    this.showLoader = false;
  }

  isChecked(quoteId: number, section: string) {
    if (section == 'active') {
      return this.selectedRfq.includes(quoteId);
    } else {
      return this.selectedArchivedRfq.includes(quoteId);
    }
  }
  // dashboard/quote/create/header?rfqId=335&quoteId=140
  openRfqDetails(rfqId: number) {
    console.log('asdddf');
    this.router.navigate(['/dashboard', 'quote', 'rfq-details', rfqId]);
  }
  openQuoteDetails(rfqId: number, quoteId: number) {
    this.router.navigate(['/dashboard', 'quote', 'create', 'header'], {
      queryParams: {
        rfqId: rfqId,
        quoteId: quoteId,
      },
    });
  }
  async restore(quoteId: number, operation: string) {
    console.log('Quote Id', quoteId);
    if (operation == 'unArchive') {
      this.showLoader = true;
      await this.SettingsService.quoteOperations({
        operation: operation,
        selectedRfqId: [quoteId],
      });
      // Optimistically move one item from archived -> active
      const idx = this.archivedDocumentData.findIndex((r: any) => r.quoteId === quoteId);
      if (idx !== -1) {
        const [row] = this.archivedDocumentData.splice(idx, 1);
        this.documentData = [row, ...this.documentData];
        this.totalRecords += 1;
        this.archivedTotalRecords = Math.max(0, this.archivedTotalRecords - 1);
        const qArchived = this.buildQuoteQuery(0);
        const qActive = this.buildQuoteQuery(1);
        this.quoteSWR.patchList(qArchived, (resp: any) => {
          const rows = (resp?.rows || []).filter((r: any) => r.quoteId !== quoteId);
          const total = Math.max(0, (resp?.totalElements ?? 0) - 1);
          return { ...resp, rows, totalElements: total };
        });
        this.quoteSWR.patchList(qActive, (resp: any) => {
          const rows = [row].concat(resp?.rows || []);
          const total = (resp?.totalElements ?? 0) + 1;
          return { ...resp, rows, totalElements: total };
        });
      }

      // Background refresh
      const qActive2 = this.buildQuoteQuery(1);
      const qArchived2 = this.buildQuoteQuery(0);
      this.quoteSWR.refresh(qActive2);
      if (this.archivedLoaded) this.quoteSWR.refresh(qArchived2);

      this.snack.open('Item unarchived', 'OK', {
        duration: 3000,
      });
      this.showLoader = false;
    }
  }

  expandedQuoteId: number | null = null;

  toggleExpandedRow(row: any) {
    this.expandedQuoteId =
      this.expandedQuoteId === row.quoteId ? null : row.quoteId;
    // Lazy compute timeline only when a row is expanded, cache on the row
    if (this.expandedQuoteId === row.quoteId && !row.statusesStages) {
      row.statusesStages = this.buildRfqStages(row);
      row.statusesStages = this.buildQuoteStages(row);
      row.statusesStages = this.buildOtherStages(row);
      this.cdr.markForCheck();
    }
  }

  ngOnDestroy() {
    if (this.quoteListSub) {
      this.quoteListSub.unsubscribe();
      this.quoteListSub = null;
    }
    if (this.quoteArchivedSub) {
      this.quoteArchivedSub.unsubscribe();
      this.quoteArchivedSub = null;
    }
  }

  getStageColorClass(label: string, row: any): string {
    if ( row.showLiveTrackerRed) {
      return 'stage-declined';
    }

    // console.log('label received ->', label);
    switch (label) {
      case 'RFQ Declined':
        return 'stage-declined';
      case 'RFQ Lapsed':
        return 'stage-lapsed';
      default:
        return 'stage-completed';
    }
  }
  getCompleteIncompleteClass(stage: any): string {
    return stage.completed ? '' : 'stage-incomplete';
  }

  buildRfqStages(rfq: any) {
    const sortedStages = (rfq.rfqStatusStages || []).sort(
      (a: any, b: any) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
    );

    const stagesArray: any[] = [];
    let hasAcknowledged = false;
    let hasDeclined = false;
    let hasUnactioned = false;
    let hasCreated = false;
    let createdDate = '';
    let hasDraft = false;

    for (let stage of sortedStages) {
      if (stage.statusName === 'Acknowledged') hasAcknowledged = true;
      else if (stage.statusName === 'Declined') hasDeclined = true;
      else if (stage.statusName === 'Unactioned') hasUnactioned = true;
      else if (stage.statusName === 'Created') hasCreated = true;
      else if (stage.statusName === 'Draft') {
        hasDraft = true;
        createdDate = this.formatDate(stage.createdAt);
      }
    }

    if (!hasUnactioned) {
      stagesArray.push({
        heading: this.getHeadingFromLabel('Unactioned', 'RFQ'),
        label: 'RFQ Unactioned',
        date: this.formatDate(rfq.rfqDate),
        completed: true,
      });
    }

    sortedStages.forEach((stage: any) => {
      if (
        sortedStages.length >= 1 &&
        `RFQ ${stage.statusName}` === sortedStages[sortedStages.length - 1].statusName
      ) {
        // skip the last stage to avoid duplication
        console.log('skipping last stage to avoid duplication for rfqId', rfq.rfqId);
      } else {
        stagesArray.push({
          heading: this.getHeadingFromLabel(stage.statusName, 'RFQ'),
          label: `RFQ ${stage.statusName}`,
          date: this.formatDate(stage.createdAt),
          completed: true,
        });
      }
    });

    // If RFQ is lapsed, append it at the end (if not already in stages)
    if (
      rfq.docStatus === 'Lapsed' &&
      !stagesArray.some((s) => s.label === 'Lapsed')
    ) {
      stagesArray.push({
        heading: this.getHeadingFromLabel('Lapsed', 'RFQ'),
        label: 'RFQ Lapsed',
        date: this.formatDate(rfq.quotedByDate),
        completed: true,
      });
    }

    // If Acknowledged is missing and Declined is also missing → add Acknowledged
    if (!hasAcknowledged && !hasDeclined && rfq.quoteStatusStages.length == 0) {
      stagesArray.push({
        heading: this.getHeadingFromLabel('Acknowledged', 'RFQ'),
        label: 'RFQ Acknowledged',
        date: '',
        completed: false,
      });
    }
    if(hasDeclined){
      rfq.quoteStatusStages=[];   // if RFQ is declined no need to show quote stages
      rfq.showLiveTrackerRed=true; // to highlight the live tracker in red
    }

    return stagesArray;
  }
  buildQuoteStages(rfq: any) {
    const sortedStages = (rfq.quoteStatusStages || []).sort(
      (a: any, b: any) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
    );

    const stagesArray: any[] = rfq.statusesStages || [];
    let hasAcknowledged = false;
    let hasDeclined = false;

    let hasSubmitted = false;
    let hasApproved = false;
    let hasRejected = false;

    let hasDraft = false;

    for (let stage of sortedStages) {
      if (stage.statusName === 'Acknowledged') hasAcknowledged = true;
      else if (stage.statusName === 'Declined') hasDeclined = true;
      else if (stage.statusName === 'Submitted') hasSubmitted = true;
      else if (stage.statusName === 'Approved') hasApproved = true;
      else if (stage.statusName === 'Rejected') hasRejected = true;
    }
    if (hasRejected) {
      rfq.showLiveTrackerRed=true; // to highlight the live tracker in red
    }

    sortedStages.forEach((stage: any) => {
      if (stage.statusName == 'Acknowledged') {    // on backend Acknowledged is mapped to created .i.e when supplier clicks the quote button the quote is being acknowledged and also capturing the creation date 
        stagesArray.push({
          heading: this.getHeadingFromLabel(stage.statusName, 'Quote'),
          label: `Quotation Created`,
          date: this.formatDate(stage.createdAt),
          completed: true,
        });
      }
      else{
        stagesArray.push({
          heading: this.getHeadingFromLabel(stage.statusName, 'Quote'),
          label: `Quotation ${stage.statusName}`,
          date: this.formatDate(stage.createdAt),
          completed: true,
        });

      }
    });
    console.log('Quote Stages ->', stagesArray);

    if (!hasSubmitted && !hasRejected && !hasApproved) {
      stagesArray.push({
        heading: this.getHeadingFromLabel('Submitted', 'Quote'),
        label: 'Quotation Submitted',
        date: '',
        completed: false,
      });
    }
    if (!hasApproved && !hasRejected) {
      stagesArray.push({
        heading: this.getHeadingFromLabel('Approved', 'Quote'),
        label: 'Quotation Approval',
        date: '',
        completed: false,
      });
    }

    return stagesArray;
  }

  buildOtherStages(rfq: any) {
    let stagesArray = rfq.statusesStages || [];

    stagesArray.push({
      heading: 'PO Confirmation',
      label: 'PO Confirmation',
      date: '',
      completed: false,
    });

    stagesArray.push({
      heading: 'Delivered Onboard',
      label: 'Delivered',
      date: '',
      completed: false,
    });

    return stagesArray;
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
    console.log(this.dropdownOpen,'this.dropdownOpen')
  }

  togglePreview(value: boolean, row?: any ) {
    this.previewSection = value;
    this.previewDocs = [];
    console.log(row.quoteHeaderAttachments,row.quoteLineItemAttachments,'row')
    if (row) {
       this.previewDocs = [...row.quoteHeaderAttachments, ...row.quoteLineItemAttachments]
    }
  }

  toggleContactPopUp(value: boolean, row?: any){
    this.showContactPopup = value;
  
    if(value){
      if(row){
  
        this.selectedBuyer = {
          companyName: row.buyerCompanyName,
          contactPerson: row.buyerContact,
          email: row.companyEmailId,
          phone: row.buyerCompanyPhoneNumber,
          address: row.buyerCompanyAddress,
          fax: row.buyerCompanyFax
      
        };
  
      }
  
    }
  }

  async downloadQuote(refNo: string, row:any ) {

    this.fullLoaderService.showLoader()
    
    let fileName = refNo +'.pdf';
    
    let data = {
      supplierId: Number(row.supplierId),
      rfqId: Number(row.rfqId),
      quoteId:Number(row.quoteId)
    }
    const pdf = await this.SettingsService.generateQuoteAttachment(data)

    const uint8Array = new Uint8Array(pdf.data);
    const blob = new Blob([uint8Array], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);


    // Create a temporary <a> element
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName; 
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    this.fullLoaderService.hideLoader()

  }


  async generateQuoteExcel(quoteId:number,rfqId: number, supplierId:number, ref:string) {

    this.fullLoaderService.showLoader()
  
    const fileName = ref +'.xlsx';
    
    const params = {
      supplierId: Number(supplierId),
      rfqId: Number(rfqId),
      quoteId:Number(quoteId)
    }
    const result = await this.SettingsService.fetchQuoteAttachmentExcelData(params)

    
    console.log(result,'result')
  
  
    const data = {
      quoteDetails:{
        quoteRef:result.quoteData.quoteRefNumber,
        quotedDate:result.quoteData.quotationDate,
        pricesGoodUntil:result.quoteData.pricesGoodUntil,
        offeredQuality: result.quoteData.offeredQualityName,
        currency:result.quoteData.currencyCode,
        onTimeDeliveryOrderBy:result.quoteData.onTimeDeliveryOrderBy,
        quotedDeliveryInDays: result.quoteData.quotedDeliveryInDays,
        incoterms: result.quoteData.incotermsName,
        incotermsLocation: result.quoteData.incotermLocations,
        paymentTerms:result.quoteData.paymentTermsCondition,
        termsAndCondition:this.convertHtmlToPlainText(result.quoteData.termsAndConditions)
      },
      rfqDetails:{
        rfqRef: result.quoteData.rfqRefNumber,
        vesselName: result.quoteData.vesselName,
        imoNumber: result.quoteData.vesselImoNumber,
        hullNumber: result.quoteData.hullNumber,
        yardName: result.quoteData.yardName,
        yearBuilt:result.quoteData.yearBuilt,
        requestedDeliveryDate: result.quoteData.requestDeliveryDate,
      },
      
      buyerDetails: {  
        name: result.quoteData.buyerCompanyName,
        address: result.quoteData.buyerCompanyAddress,
        contact: result.quoteData.buyerContact,
        phone: result.quoteData.buyerCompanyPhone,
        email: result.quoteData.buyerCompanyEmail,
        mpsBuyerCode: result.quoteData.buyerMpsCode,
      },
      supplierDetails: {
        name: result.quoteData.supplierCompanyName,
        address: `${result.quoteData.supplierStreet}, ${result.quoteData.supplierCity}, ${result.quoteData.supplierCountry}, ${result.quoteData.supplierZipcode}`,
        contact: result.quoteData.supplierContact,
        phone: result.quoteData.supplierPhone,
        email: result.quoteData.supplierEmail,
        mpsSupplierCode: result.quoteData.supplierMpsCode,
      },
      freightForwarderDetails: {
        PIC: result.quoteData.qffpic,
        phone: result.quoteData.qffphone,
        fax: result.quoteData.qfffax,
        email: result.quoteData.qffemailId,
        address: result.quoteData.qffaddress,
      },
     
      portDetails: {
        portName: result.quoteData.portName,
        vesselETA: result.quoteData.vesselEta,
        vesselETD: result.quoteData.vesselEtd,
      },
      costSummary:{
        lineItemSubtotal:parseFloat(result.quoteData.lineItemSubtotal || 0).toFixed(3),
        generalDiscountType: result.quoteData.generalDiscountType || 'percentage',
        generalDiscountValue: parseFloat(result.quoteData.generalDiscountValue || 0),
        generalDiscountAmount: (result.quoteData.generalDiscountType || 'percentage') === 'percentage'
          ? (parseFloat(result.quoteData.lineItemSubtotal || 0) * parseFloat(result.quoteData.generalDiscountValue || 0) / 100).toFixed(3)
          : parseFloat(result.quoteData.generalDiscountValue || 0).toFixed(3),
        taxAmount: parseFloat(result.quoteData.taxAmount || 0).toFixed(3),
        otherCharges:result.quoteData.quoteLineItemFreight,
        totalAdditionalCOst:parseFloat(result.quoteData.freightValue || 0).toFixed(3),
        currency:result.quoteData.currencyCode,
        grandTotal: parseFloat(result.quoteData.subtotal || 0).toFixed(3)
      },
      lineItems: result.lineItemData.map((item: {
        partNo: any;
        supplierPartNo: any;
        description: any;
        supplierQuantity: any;
        unitOfMeasure: any;
        supplierUOM: any;
        unitCost: any;
        discountPercent: any;
        totalCost: any;
        leadTime: any;
        supplierComment: any; partNumber: any; itemDescription: any; quantity: any; uom: any; buyerComments: any; 
}, index: number) => ({
        srNo: index + 1,
        partNumber: item.partNo,
        supplierPartNumber: item.supplierPartNo,
        itemDescription: item.description,
        requestedQty: item.quantity,
        quotedQuantity: item.supplierQuantity,
        requestedUom: item.unitOfMeasure,
        quotedUom: item.supplierUOM,
        unitCost: item.unitCost,
        discount: item.discountPercent,
        totalCost: item.totalCost,
        leadDays: item.leadTime,
        supplierRemarks: item.supplierComment || ''
       
        
      }))
    };
  
    
  
    // Dynamic import to keep initial bundle small
    const Excel = await import('exceljs');
    const fileSaverMod = await import('file-saver');
    const saveAs = (fileSaverMod as any).saveAs || (fileSaverMod as any).default;
    const workbook = new Excel.Workbook();
    const ws = workbook.addWorksheet('Quotation');

    // === TITLE ===
    ws.mergeCells('A1:G1');
    const title = ws.getCell('A1');
    title.value = 'Quotation';
    title.font = { size: 18, bold: true, color: { argb: '1F4E78' } };
    title.alignment = { horizontal: 'center', vertical: 'middle' };
    ws.addRow([]);

    // === QUOTATION DETAILS ===
    const quoteHeader = ws.addRow(['QUOTATION DETAILS']);
    quoteHeader.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'D9E1F2' },
    };
    quoteHeader.getCell(1).font = { bold: true };
    ws.addRow([]);

    // Quotation Info
    const quoteInfo = [
      [
        'Quote Ref:',
        data.quoteDetails.quoteRef,
        '',
        'On-Time Delivery Order By:',
        data.quoteDetails.onTimeDeliveryOrderBy,
      ],
      [
        'Quoted Date:',
        data.quoteDetails.quotedDate,
        '',
       
        'Quoted Delivery in Days:',
        data.quoteDetails.quotedDeliveryInDays,
      ],
      [
        'Prices Good Until:',
        data.quoteDetails.pricesGoodUntil,
        '',
        
        'Incoterms:',
        data.quoteDetails.incoterms,
      ],
      [
        'Offered Quality:',
        data.quoteDetails.offeredQuality,
        '',
        'Incoterms Location:',
        data.quoteDetails.incotermsLocation,
      ],
      [
        'Currency:',
        data.quoteDetails.currency,
        '',
        'Payment Terms:',
        data.quoteDetails.paymentTerms,
      ],
    ];
    quoteInfo.forEach((r) => {
      const row = ws.addRow(r);
      row.eachCell((c) => (c.alignment = { vertical: 'middle' }));
    });
    ws.addRow([]);

    // === BUYER AND SUPPLIER DETAILS ===
    const BsHeader = ws.addRow(['Buyer Details', '', '', 'Supplier Details']);
    BsHeader.eachCell(c => {
      c.font = { bold: true };
      c.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF2CC' } };
    });
    ws.addRow([]);
    // const BsmaxRows = Math.max(
    //   Object.keys(data.buyerDetails).length,
    //   Object.keys(data.supplierDetails).length
    // );

    // const bd = Object.entries(data.buyerDetails);
    // const bpad = Array(BsmaxRows - bd.length).fill(['', '']);
    // const bpad2 = Array(BsmaxRows - Object.entries(data.supplierDetails).length).fill(['', '']);
    // const bpadData = bd.concat(bpad);
    // const supp = Object.entries(data.supplierDetails).concat(bpad2);

    // for (let i = 0; i < BsmaxRows; i++) {
    //   ws.addRow([
    //     bpadData[i][0],
    //     bpadData[i][1],
    //     '',
    //     supp[i][0],
    //     supp[i][1],
    //   ]);
    // }
    const buyerEntries = Object.entries(data.buyerDetails).map(([key, value]) => [
      labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()),
      value
    ]);
    
    const supplierEntries = Object.entries(data.supplierDetails).map(([key, value]) => [
      labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()),
      value
    ]);
    
    // Pad so both arrays have the same length
    const BsmaxRows = Math.max(buyerEntries.length, supplierEntries.length);
    const paddedBuyer = [...buyerEntries, ...Array(BsmaxRows - buyerEntries.length).fill(['', ''])];
    const paddedSupplier = [...supplierEntries, ...Array(BsmaxRows - supplierEntries.length).fill(['', ''])];
    
  
    for (let i = 0; i < BsmaxRows; i++) {
      const row = ws.addRow([
        paddedBuyer[i][0], paddedBuyer[i][1],
        '',
        paddedSupplier[i][0], paddedSupplier[i][1]
      ]);
    
    
      row.eachCell(cell => {
        cell.alignment = { vertical: 'middle', wrapText: true };
      });
    }

    ws.addRow([]);


    const rfqHeader = ws.addRow(['RFQ Details']);
    rfqHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'f9bccb' } };
    rfqHeader.getCell(1).font = { bold: true };
    ws.addRow([]);
    ws.addRow(['Vessel Name', data.rfqDetails.vesselName]);
    ws.addRow(['Vessel IMO', data.rfqDetails.imoNumber]);
    ws.addRow(['Hull Number', data.rfqDetails.hullNumber]);
    ws.addRow(['Yard Name', data.rfqDetails.yardName]);
    ws.addRow(['Build Year', data.rfqDetails.yearBuilt]);
    ws.addRow(['Vessel ETA', data.portDetails.vesselETA]);
    ws.addRow(['Vessel ETA', data.portDetails.vesselETD]);
    ws.addRow([]);
    ws.addRow([]);


    const freightHeader = ws.addRow(['Freight Details']);
    freightHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FCE4D6' } };
    freightHeader.getCell(1).font = { bold: true };
    ws.addRow([]);
    ws.addRow(['PIC', data.freightForwarderDetails.PIC]);
    ws.addRow(['Phone', data.freightForwarderDetails.phone]);
    ws.addRow(['Fax', data.freightForwarderDetails.fax]);
    ws.addRow(['Email', data.freightForwarderDetails.email]);
    ws.addRow(['Address', data.freightForwarderDetails.address]);
    ws.addRow([]);
    ws.addRow([]);

  
    // === LINE ITEMS ===
    const liHeader = ws.addRow(['Line Items']);
    liHeader.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'BDD7EE' },
    };
    liHeader.getCell(1).font = { bold: true };
    ws.addRow([]);

    const tableHeader = ws.addRow([
      'Sr. No',
      'Part Number',
      'Supplier Part Number',
      'Item Description',
      'Requested Qty',
      'Quoted Qty',
      'Requested UOM',
      'Quoted UOM',
      'Unit Cost',
      'Discount',
      'Total Cost' ,
      'Lead Days',
      'Supplier Remarks'
    ]);
    tableHeader.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'D9D9D9' },
      };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    // Add Line Items
    data.lineItems.forEach((item: {
      supplierRemarks: any; srNo: any; partNumber: any; supplierPartNumber: any; itemDescription: any; requestedQty: any; quotedQuantity: any; requestedUom: any; quotedUom: any; unitCost: any; discount: any; totalCost: any; leadDays: any; supplierComment: any; 
}) => {
      const row = ws.addRow([
        item.srNo,
        item.partNumber,
        item.supplierPartNumber,
        item.itemDescription,
        item.requestedQty,
        item.quotedQuantity,
        item.requestedUom,
        item.quotedUom,
        item.unitCost,
        item.discount,
        item.totalCost,
        item.leadDays,
        item.supplierRemarks

      ]);
      row.eachCell((cell) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
        cell.alignment = { wrapText: true, vertical: 'middle' };
      });
    });

    ws.addRow([]);



    const costSummaryHeader = ws.addRow(['Cost Summary']);
    costSummaryHeader.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'F9F9F9' },
    };
    costSummaryHeader.getCell(1).font = { bold: true };
    ws.addRow([]);

    // Cost Summary Table
    const costSummaryTableHeader = ws.addRow(['Description', 'Amount']);
    costSummaryTableHeader.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'D9D9D9' },
      };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    // Line Total Amount
    const lineTotalRow = ws.addRow([
      'Line Total Amount',
      data.costSummary.lineItemSubtotal,
    ]);
    lineTotalRow.eachCell((cell) => {
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    // General Discount Amount (only if > 0)
    if (parseFloat(data.costSummary.generalDiscountAmount) > 0) {
      const generalDiscountRow = ws.addRow([
        'General Discount Amount',
        `${data.costSummary.generalDiscountAmount}`,
      ]);
      generalDiscountRow.eachCell((cell) => {
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
      });
    }

    // Adding Additional Charges 
    let totalAdditionalCharges = 0;
    data.costSummary.otherCharges.forEach((charge: { freightDescription: any; freightValue: number; }) => {
      const row = ws.addRow([charge.freightDescription, charge.freightValue]);
      row.eachCell((cell) => {
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
      });
      totalAdditionalCharges += charge.freightValue;
    });

    // Total Additional Cost
    const totalAdditionalCostRow = ws.addRow([
      'Total Additional Cost',
      totalAdditionalCharges,
    ]);
    totalAdditionalCostRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    // Tax Amount (only if > 0)
    if (parseFloat(data.costSummary.taxAmount) > 0) {
      const taxAmountRow = ws.addRow([
        'Tax Amount',
        data.costSummary.taxAmount,
      ]);
      taxAmountRow.eachCell((cell) => {
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
      });
    }

    // Grand Total
    const grandTotalRow = ws.addRow([
      'Grand Total',
      `${data.costSummary.grandTotal} ${data.costSummary.currency}`,
    ]);
    grandTotalRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    ws.addRow([]);

    const termsHeader = ws.addRow(['Terms And Conditions']);
    termsHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FCE4D6' } };
    termsHeader.getCell(1).font = { bold: true };
    ws.addRow([]);
    ws.addRow([data.quoteDetails.termsAndCondition]);
    ws.addRow([]);
    ws.addRow([]);


    // === VSMPS Buyer and Supplier section ===
    ws.addRow([`From VSMPS Buyer: ${data.buyerDetails.mpsBuyerCode}`]);
    ws.addRow([data.buyerDetails.name]);
    ws.addRow([data.buyerDetails.address]);

    ws.addRow([]);

    ws.addRow([`To VSMPS Supplier: ${data.supplierDetails.mpsSupplierCode}`]);
    ws.addRow([data.supplierDetails.name]);
    ws.addRow([data.supplierDetails.address]);

    ws.addRow([]);
    ws.addRow(['Copyright © Varuna Sentinels BV. All rights reserved.']);

    // === AUTO WIDTH ===
    const colCount = ws.actualColumnCount;
    for (let i = 1; i <= colCount; i++) {
      let maxLen = 12;
      ws.eachRow({ includeEmpty: true }, (r) => {
        const val = r.getCell(i).value;
        const len = val ? val.toString().length : 0;
        if (len > maxLen) maxLen = len;
      });
      ws.getColumn(i).width = Math.min(maxLen + 4, 40);
    }
  
    workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, fileName);
    });
  
  
    this.fullLoaderService.hideLoader()
  
  }

  convertHtmlToPlainText(html: string): string {
    if (!html) return '';

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    // Replace <li> with line breaks + bullet
    tempDiv.querySelectorAll('li').forEach(li => {
      li.insertAdjacentText('beforebegin', '\n• ');
    });

    // Replace <br> and block tags with line breaks
    const blockTags = ['p', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol'];
    blockTags.forEach(tag => {
      tempDiv.querySelectorAll(tag).forEach(el => {
        el.insertAdjacentText('beforebegin', '\n');
      });
    });

    const text = tempDiv.textContent || '';
    return text.replace(/\n{2,}/g, '\n').trim(); // Remove extra empty lines
  }
  
  
}
